import {riskCheck} from '@/utils/riskInit';
import {RiskCheckEv} from '@/dicts/qualify';
import {API} from '../api';

// 激活实名所有认证方式submit接口
export const API_IS_RISK_SDK = {
    // 认证方式 enterprise
    [API.availableAuth]: () => {
        return location.hash.includes('#/qualify/choices/company') ? RiskCheckEv.enterprise : RiskCheckEv.personal;
    },
    // 个人刷脸
    [API.personFaceSubmit]: RiskCheckEv.face_submit,
    // 发送验证码
    [API.sendPerBankAuthCode]: RiskCheckEv.card_send_code,
    // 个人证件认证
    [API.submitPersonCertificate]: RiskCheckEv.certificate_submit,
    // 个人银行卡
    [API.submitPerBank]: RiskCheckEv.card_submit,
    // 刷脸确认
    [API.faceLog]: RiskCheckEv.face_start,
    // 企业对公打款
    [API.submitCompTransfer]: RiskCheckEv.remit_submit,
    // 对公打款验证金额
    [API.verifyCompTransfer]: RiskCheckEv.remit_verify,
    // 企业充值认证
    [API.createPaymentProcess]: RiskCheckEv.recharge_apply,
    // 充值认证提交
    [API.submitPayment]: RiskCheckEv.recharge_submit,
    // 企业法人刷脸
    [API.legalLivingSubmit]: RiskCheckEv.legal_face_submit,
    // 企业被授权人刷脸
    [API.legalAuthorizedLivingSubmit]: RiskCheckEv.authorized_submit,
    // pass同步实名
    [API.syncPass]: RiskCheckEv.pass_sync,
};

export async function getRiskSdkHeaders(getEv: (() => RiskCheckEv) | RiskCheckEv) {
    const ev: RiskCheckEv = typeof getEv === 'function' ? getEv() : getEv;
    const headers = await riskCheck(ev);
    let headerString = '';
    try {
        headerString = window.btoa ? window.btoa(JSON.stringify(headers)) : JSON.stringify(headers);
    } catch (e) {
        headerString = '';
    }
    // 请求heaer当cookie+x-bce-js-report超过5500左右时会报bad request
    // 由于document.cookie无法获取到全部cookie，httponly的cookie无法获取，大概有1700的字符长度
    // 所以如果安全sdk+cookie的长度大于4000，则不设置安全sdk header
    // const cookieLengthLimit = document.cookie.length + headerString.length > 4000;
    // return cookieLengthLimit ? {} : {
    //     'x-bce-js-report': headerString,
    // };
    return {
        'x-bce-js-report': headerString,
    };
}

export async function getNeedRiskHeader(url: string) {
    const needRiskCheck = API_IS_RISK_SDK[url];
    if (needRiskCheck) {
        // 去除风险header避免请求400报错
        const header = await getRiskSdkHeaders(needRiskCheck);
        return Promise.resolve(header);
    }
    return Promise.resolve();
}
